import {
  faClipboard,
  faComment,
  faEnvelope,
  faExpand,
  faFileDownload,
  faCircleQuestion,
  faList,
  faMap,
  faRoute,
  faSpinner,
  faTimes,
  faTruck,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {
  Suspense,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useNavigate } from 'react-router';

import CustomDatePickerDashboard from '../../components/agv-header-date-picker';

import fr from 'date-fns/locale/fr';
import { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'simplebar-react/dist/simplebar.min.css';

import 'react-circular-progressbar/dist/styles.css';

import SkeletonLoader from 'tiny-skeleton-loader-react';
import './home.scss';

import ReactDatePicker from 'react-datepicker';
import { useSelector } from 'react-redux';
import GenericPageContainer from '../../components/agv-generic-page-container';

import {
  Checkbox,
  Dialog,
  DialogPanel,
  Switch,
  Tab,
  TabGroup,
  TabList,
  TabPanel,
  Transition,
  TransitionChild,
} from '@headlessui/react';
import moment from 'moment';
import { io } from 'socket.io-client';
import useGetDashboard from '../../api/dashboard/useGetDashboard';
import useGetTourDetails from '../../api/tours/useGetToursDetails';
import AgrivitechCheckbox from '../../components/agv-checkbox/agv-checkbox';
import GenericTableSkeleton from '../../components/agv-generic-table/genericTableSkeleton';
import Row from '../../components/agv-generic-table/row';
import HeaderButton from '../../components/agv-header-button';
import Status from '../../components/agv-status/index';
import { STATUS_ENUM } from '../../components/agv-status/status-enum';
import AlimentTypeTag from '../../components/fleet-aliment-type-tag/aliment-type-tag';
import { ALIMENT_TYPE_ENUM } from '../../components/fleet-aliment-type-tag/aliment-type.enum';
import { DELIVERY_DETAIL_TYPE } from '../../enums/delivery-detail.enum';
import DOCUMENT_TYPE from '../../enums/documents.enum';
import { MODAL_SIZE, MODAL_SIZE_STYLE } from '../../enums/modal-size.enum';
import { reserves_types } from '../../enums/reserve-status.enum';
import { step_status } from '../../enums/step-status.enum';
import { tour_status } from '../../enums/tour-status';
import { computeRowForOneDeliveryDetail } from '../../utils/silo.util';
import ModalReserve from '../Reserves/ModalReserve';
import ModalTour from '../Tour/ModalTour';
import BarChartComponent from './Dashboard/barChart';
import Kpi from './Dashboard/kpi';
import PieChartComponent from './Dashboard/pieChart';
import { returnReserveSubtitle } from '../../utils/reserve.util';
import Products from '../../components/fleet-silos-display';
import ModalReserveV2 from '../Reserves/ModalReserveV2';
import { returnCriticalityDiv } from '../../utils/criticalities';
import ResponsiblesNotificationModal from './ResponsiblesNotificationModal';
import { useIsMobile } from '../../utils/useIsMobile';
import { PRODUCT_TOUR_QUERY_PARAM } from '../../components/fleet-product-tour';

moment.locale('fr');

registerLocale('fr', fr);

const MapFleetDashboard = React.lazy(
  () => import('./Dashboard/mapFleetDashboard_v3')
);

const VehiclesViewMode = Object.freeze({
  LIST: 'list',
  GRID: 'grid',
  MAP: 'map',
});

const HomeV3 = () => {
  let socketRef = useRef(null);

  const isMobile = useIsMobile();

  /******
   *
   * States
   *
   ******/

  const [selectedTourID, setSelectedTourID] = useState(null);
  const [selectedTour, setSelectedTour] = useState(null);

  const [isMapReady, setIsMapReady] = useState(false);
  const [isMapUpdating, setIsMapUpdating] = useState(false);

  const [openMapModal, setOpenMapModal] = useState(false);

  const [openTourModal, setOpenTourModal] = useState(false);

  const [modalHandleReserve, setModalHandleReserve] = useState(false);
  const [selectedReserve, setSelectedReserve] = useState(null);

  const showVehiclesViewToggle = true;
  const [vehiclesViewMode, setVehiclesViewMode] = useState(
    VehiclesViewMode.MAP
  );

  const [isResumeDownloading, setIsResumeDownloading] = useState(false);
  const [openResponsiblesModal, setOpenResponsiblesModal] = useState(false);

  let {
    dashboardData,
    isLoading,
    error,
    filters,
    updateFilter,
    refetch: getData,
    downloadResume,
  } = useGetDashboard();

  const { details, refetch: getTourDetails } =
    useGetTourDetails(selectedTourID);

  const BASE_URL = useSelector((state) => state.BASE_URL);
  const features = useSelector((state) => state.features);
  const userFactory = useSelector((state) => state.user_factory);
  const config = useSelector((state) => state.config);

  const ref = useRef();
  const sectionRef = useRef(null);
  const navigate = useNavigate();

  /******
   *
   * functions
   *
   ******/

  function formatAddress(address) {
    if (!address) {
      return 'Adresse non disponible';
    }

    const { address_number, street, city, zipcode } = address;

    const formattedStreet = address_number
      ? `${address_number} ${street}`
      : street;
    const formattedAddress = [formattedStreet, city, zipcode]
      .filter(Boolean)
      .join(', ');

    return formattedAddress || 'Adresse non disponible';
  }

  const handleTourModal = (selected_tour) => {
    setSelectedTour(selected_tour);
    setOpenTourModal(true);
  };

  /******
   *
   * Effects
   *
   ******/

  useEffect(() => {
    const token = localStorage.getItem('fleetToken');
    socketRef.current = io(process.env.REACT_APP_SOCKET_API_URL, {
      autoConnect: false,
      auth: {
        token,
      },
    });

    return () => {
      if (socketRef?.current) {
        console.log(
          `Désactivation du serveur de socket car la page a été quittée.`
        );
        socketRef.current.off();
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    const today = new Date();
    const isToday =
      filters?.date &&
      filters?.date.getDate() === today?.getDate() &&
      filters?.date.getMonth() === today?.getMonth() &&
      filters?.date.getFullYear() === today?.getFullYear();

    // Nettoyage systématique : retirer les listeners et déconnecter
    // (couvre les états connected ET connecting)
    if (socketRef?.current) {
      socketRef.current.off('connect');
      socketRef.current.off('disconnect');
      socketRef.current.off('connect_error');
      socketRef.current.off('refresh_dashboard');
      if (socketRef.current.connected || socketRef.current.active) {
        console.log(
          `Désactivation pré-emptive dans le cas où plusieurs connexion existeraient.`
        );
        socketRef.current.disconnect();
      }
    }

    if (userFactory != undefined && isToday) {
      console.log('Listening des events socket.io');
      const factoryId = userFactory === '' ? null : userFactory;

      socketRef.current.on('connect', () => {
        console.log(
          `Connecté au serveur de socket, et connexion à la room : ${factoryId ?? 'ALL'}`
        );
        socketRef.current.emit('join_room', { factoryId });
      });

      socketRef.current.on('disconnect', () => {
        console.log('Déconnecté du serveur de sockets.');
      });

      socketRef.current.on('connect_error', (error) => {
        console.error('Erreur de connexion au socket:', error);
      });

      socketRef.current.on('refresh_dashboard', (data) => {
        console.log(
          "Réception de l'event refresh_dashboard, on re-get les datas"
        );
        const randomTimer = Math.floor(Math.random() * 1000);
        console.log(`Waiting for ${randomTimer}ms`);
        setTimeout(() => {
          getData();
        }, randomTimer);
      });

      console.log('Connexion au socket');
      socketRef.current.connect();
    }

    return () => {
      if (socketRef?.current) {
        console.log(
          `Désactivation des events du serveur de socket les paramètres ont changés`
        );
        socketRef.current.off('connect');
        socketRef.current.off('disconnect');
        socketRef.current.off('connect_error');
        socketRef.current.off('refresh_dashboard');
        socketRef.current.disconnect();
      }
    };
  }, [userFactory, filters.date]);

  useEffect(() => {
    setSelectedTour();
    setSelectedTourID();
  }, [openMapModal]);

  useEffect(() => {
    setSelectedTour(details);
    // Lorsque details est mis à jour, réinitialisez le scroll en haut de la balise section
    if (sectionRef.current) {
      sectionRef.current.scrollTop = 0;
    }
  }, [details]);

  useEffect(() => {
    selectedReserve && setModalHandleReserve(true);
  }, [selectedReserve]);

  // Handle the tour-item click
  useEffect(() => {
    // if a tour is selected, set it to the selected tour state
    if (selectedTourID) {
      // Tour is already selected, no action needed
    } else {
      // else, set it to null
      setIsMapUpdating(true);
      setTimeout(() => {
        setSelectedTour(null);
        setIsMapUpdating(false);
      }, 100);
    }
  }, [dashboardData]);

  const computeTourTitle = useCallback(
    (tour) => {
      const tourTitlePart = [];

      if (tour?.vehicule_key) {
        tourTitlePart.push(`Véhicule ${tour.vehicule_key}`);
      }

      if (tour?.imat) {
        tourTitlePart.push(tour.imat);
      }

      if (tour?.label || tour?.vehicle_type) {
        if (tour?.label) {
          tourTitlePart.push(tour.label);
        } else {
          tourTitlePart.push(tour.vehicle_type);
        }
      }

      return tourTitlePart.join(' - ');
    },
    [dashboardData?.dashboardDatas?.vehicles?.tours]
  );

  const handleReserveFields = (reserve) => {
    const fields = [];

    fields.push({
      name: 'Client',
      value:
        reserve?.receiver_key && reserve?.receiver_name
          ? `${reserve?.receiver_key} - ${reserve?.receiver_name}`
          : reserve?.receiver_name
            ? reserve?.receiver_name
            : '-',
    });

    if (reserve?.reserve_reason?.criticality) {
      fields.push({
        name: '',
        value: returnCriticalityDiv(reserve?.reserve_reason?.criticality),
      });
    }

    return fields;
  };

  const handleResumeDownload = async () => {
    setIsResumeDownloading(true);
    const response = await downloadResume(filters?.date);
    console.log(response);
    setIsResumeDownloading(false);

    if (response?.url) {
      window.open(response?.url, '_blank');
    }
  };

  /******
   *
   * Return
   *
   ******/
  return (
    <>
      <GenericPageContainer
        title={'Tour de contrôle'}
        page={'Dashboard'}
        subtitle={`Pilotez votre flotte de véhicules depuis cette page pour la date du ${filters?.date?.toLocaleDateString(
          'fr-FR',
          {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          }
        )}.`}
        filters={
          <>
            <div className="tw-relative" data-tour="dashboard-date-picker">
              <ReactDatePicker
                selected={filters.date}
                onChange={(date) => updateFilter('date', date)}
                customInput={<CustomDatePickerDashboard />}
                locale="fr"
                dateFormat="dd MMM yyyy"
              />
            </div>
            {features?.OTHERS?.BACKOFFICE?.canDownloadDashboardResume && (
              <HeaderButton
                onClick={handleResumeDownload}
                disabled={
                  !window.open ||
                  isResumeDownloading ||
                  !dashboardData?.dashboardDatas?.vehicles?.vehicle_count
                }
                text={
                  isResumeDownloading
                    ? 'Téléchargement en cours...'
                    : 'Télécharger le résumé'
                }
                icon={isResumeDownloading ? faSpinner : faFileDownload}
              />
            )}

            {config?.client_id == 6 && (
              <HeaderButton
                onClick={() => setOpenResponsiblesModal(true)}
                disabled={false}
                text={'Notifier les commerciaux'}
                icon={faEnvelope}
              />
            )}

            {!isMobile && (
              <div data-tour="dashboard-tour-button">
                <HeaderButton
                  onClick={() => navigate(`/?${PRODUCT_TOUR_QUERY_PARAM}=1`)}
                  text={'Visite guidée'}
                  icon={faCircleQuestion}
                />
              </div>
            )}
          </>
        }
      >
        {/* Nouveau contenu */}

        {isMobile ? (
          // VERSION MOBILE - AVEC TABS
          <TabGroup className="tw-mt-1">
            <TabList className="tw-flex tw-gap-2 tw-mb-4 tw-border-b tw-border-gray-200">
              <Tab
                className={({ selected }) =>
                  `tw-px-4 tw-py-1 tw-text-xs tw-font-semibold tw-rounded-full tw-border-none ${
                    selected
                      ? 'tw-bg-primary tw-text-white'
                      : 'tw-bg-[rgba(0,0,0,0.1)] tw-text-gray-700'
                  }`
                }
              >
                KPIs & Graphiques
              </Tab>
              <Tab
                className={({ selected }) =>
                  `tw-px-4 tw-py-1 tw-text-xs tw-font-semibold tw-rounded-full tw-border-none ${
                    selected
                      ? 'tw-bg-primary tw-text-white'
                      : 'tw-bg-[rgba(0,0,0,0.1)] tw-text-gray-700'
                  }`
                }
              >
                Réserves
              </Tab>
              <Tab
                className={({ selected }) =>
                  `tw-px-4 tw-py-1 tw-text-xs tw-font-semibold tw-rounded-full tw-border-none ${
                    selected
                      ? 'tw-bg-primary tw-text-white'
                      : 'tw-bg-[rgba(0,0,0,0.1)] tw-text-gray-700'
                  }`
                }
              >
                Véhicules
              </Tab>
            </TabList>

            {/* TAB 1: KPIs et Graphiques */}
            <TabPanel>
              <div className="tw-container tw-mx-auto tw-grid tw-grid-cols-2 tw-gap-4 tw-mb-4">
                <Kpi kpi_data={dashboardData?.dashboardDatas?.kpis?.[0]} />
                <Kpi kpi_data={dashboardData?.dashboardDatas?.kpis?.[1]} />
                <Kpi kpi_data={dashboardData?.dashboardDatas?.kpis?.[2]} />
                <Kpi kpi_data={dashboardData?.dashboardDatas?.kpis?.[3]} />
              </div>

              <div className="tw-container tw-mx-auto tw-grid tw-grid-cols-1 tw-gap-4 pb-5">
                <div className="tw-rounded tw-bg-white tw-overflow-y-auto tw-h-[35vh]">
                  {isLoading ? (
                    <SkeletonLoader height={'100%'} width={'100%'} />
                  ) : (
                    <PieChartComponent
                      pie_chart_data={
                        dashboardData?.dashboardDatas?.pie_chart_datas?.[0]
                      }
                      startAngle={630}
                      endAngle={280}
                      innerRadius={'50%'}
                      fill="#8884d8"
                      paddingAngle={5}
                      hasTooltip={true}
                    />
                  )}
                </div>
                {(isLoading ||
                  dashboardData?.dashboardDatas?.bar_chart_datas?.length >
                    0) && (
                  <div className="tw-rounded tw-bg-white tw-overflow-y-auto tw-h-[35vh]">
                    {isLoading ? (
                      <SkeletonLoader height={'100%'} width={'100%'} />
                    ) : (
                      <BarChartComponent
                        bar_chart_data={
                          dashboardData?.dashboardDatas?.bar_chart_datas?.[0]
                        }
                      />
                    )}
                  </div>
                )}
              </div>
            </TabPanel>

            {/* TAB 2: Réserves */}
            <TabPanel className="tw-overflow-y-auto pb-5">
              <div className="tw-rounded tw-bg-white tw-overflow-y-auto">
                <div className="listHeader tw-p-5 tw-flex tw-justify-between">
                  <div className="tw-font-semibold tw-text-xs">
                    Réserves non traitées :{' '}
                    {dashboardData?.dashboardDatas?.reserves_to_solve?.length}
                  </div>
                  <a
                    href="/reserves"
                    className="tw-font-semibold tw-text-xs tw-underline tw-text-[#29A9A3]"
                  >
                    Voir plus
                  </a>
                </div>

                <div className="tw-rounded-md tw-bg-white tw-divide-solid tw-divide-x-0 tw-divide-y tw-divide-background tw-overflow-x-auto tw-cursor-pointer">
                  {isLoading ? (
                    <GenericTableSkeleton />
                  ) : (
                    dashboardData?.dashboardDatas?.reserves_to_solve?.map(
                      (reserve) => (
                        <div
                          onClick={() => setSelectedReserve(reserve)}
                          className=""
                          key={`reserve_${reserve?.id}`}
                        >
                          <Row
                            iconColor={'tw-text-checklist-common'}
                            key={`reserveRow_${reserve?.id}`}
                            title={reserve.message || ''}
                            subtitle={returnReserveSubtitle(
                              reserve,
                              features,
                              true
                            )}
                            icon={faClipboard}
                            fields={handleReserveFields(reserve)}
                          />
                        </div>
                      )
                    )
                  )}
                </div>
              </div>
            </TabPanel>

            {/* TAB 3: Véhicules */}
            <TabPanel className="tw-overflow-y-auto pb-5">
              <div className="tw-rounded tw-bg-white tw-overflow-y-auto">
                <div className="listHeader tw-p-5 tw-flex tw-justify-between">
                  <div className="tw-font-semibold tw-text-xs">
                    {dashboardData?.dashboardDatas?.vehicles?.vehicle_count ||
                      0}{' '}
                    Véhicules pour{' '}
                    {dashboardData?.dashboardDatas?.vehicles?.tours?.length ||
                      0}{' '}
                    tournées :{' '}
                  </div>
                  <div
                    onClick={() => navigate('tours')}
                    className="tw-font-semibold tw-cursor-pointer tw-text-xs tw-underline tw-text-[#29A9A3]"
                  >
                    Voir plus
                  </div>
                </div>

                <div className="tw-rounded-md tw-bg-white tw-divide-solid tw-divide-x-0 tw-divide-y tw-divide-background tw-overflow-x-auto">
                  {isLoading ? (
                    <GenericTableSkeleton />
                  ) : (
                    dashboardData?.dashboardDatas?.vehicles?.tours?.map(
                      (tour) => (
                        <div
                          onClick={() =>
                            handleTourModal(tour?.current_or_next_tour)
                          }
                          className=""
                          key={`tour_${tour?.current_or_next_tour?.tour_key}`}
                        >
                          <Row
                            iconColor={'tw-text-checklist-common'}
                            key={`tourRow_${tour?.current_or_next_tour?.tour_key}`}
                            title={computeTourTitle(tour)}
                            subtitle={
                              'Tour ' +
                              tour?.current_or_next_tour?.tour_number +
                              ' - Étape ' +
                              tour?.finalized_steps_count +
                              ' sur ' +
                              tour?.total_steps_count
                            }
                            icon={faTruck}
                            status={
                              tour_status?.properties[
                                tour?.current_or_next_tour?.status
                              ]?.color
                            }
                            statusText={
                              tour_status?.properties[
                                tour?.current_or_next_tour?.status
                              ]?.display_name
                            }
                            statusStyle={'tw-w-[90px]'}
                            style={'tw-cursor-pointer'}
                            fields={
                              tour?.current_or_next_tour?.tour_index
                                ? [
                                    {
                                      name: 'Tournée',
                                      value:
                                        tour?.current_or_next_tour?.tour_index +
                                        ' sur ' +
                                        tour?.tour_count,
                                    },
                                  ]
                                : []
                            }
                          />
                        </div>
                      )
                    )
                  )}
                </div>
              </div>
            </TabPanel>
          </TabGroup>
        ) : (
          // VERSION DESKTOP - LAYOUT ORIGINAL
          <div className="tw-max-h-screen">
            <div className="tw-container tw-mx-aut tw-grid tw-grid-flow-row tw-grid-cols-4 tw-grid-rows-1 tw-gap-4 tw-mb-4 tw-mt-10">
              <Kpi kpi_data={dashboardData?.dashboardDatas?.kpis?.[0]} />
              <Kpi kpi_data={dashboardData?.dashboardDatas?.kpis?.[1]} />
              <Kpi kpi_data={dashboardData?.dashboardDatas?.kpis?.[2]} />
              <Kpi kpi_data={dashboardData?.dashboardDatas?.kpis?.[3]} />
            </div>

            <div className="tw-container tw-mx-auto tw-h-[35vh] tw-overflow-hidden tw-grid tw-grid-flow-row tw-grid-cols-2 tw-grid-rows-1 tw-gap-4 tw-mb-4">
              <div className="tw-rounded tw-bg-white tw-overflow-y-auto">
                <div className="listHeader tw-p-5 tw-flex tw-justify-between ">
                  <div className=" tw-font-semibold tw-text-xs">
                    Réserves non traitées :{' '}
                    {dashboardData?.dashboardDatas?.reserves_to_solve?.length}
                  </div>
                  <a
                    href="/reserves"
                    className=" tw-font-semibold tw-text-xs tw-underline tw-text-[#29A9A3]"
                  >
                    Voir plus
                  </a>
                </div>

                <div className="tw-rounded-md tw-bg-white tw-divide-solid tw-divide-x-0 tw-divide-y tw-divide-background tw-overflow-x-auto tw-cursor-pointer">
                  {isLoading ? (
                    <GenericTableSkeleton />
                  ) : (
                    dashboardData?.dashboardDatas?.reserves_to_solve?.map(
                      (reserve) => (
                        <div
                          onClick={() => setSelectedReserve(reserve)}
                          className=""
                          key={`reserve_${reserve?.id}`}
                        >
                          <Row
                            iconColor={'tw-text-checklist-common'}
                            key={`reserveRow_${reserve?.id}`}
                            title={reserve.message || ''}
                            subtitle={returnReserveSubtitle(
                              reserve,
                              features,
                              true
                            )}
                            icon={faClipboard}
                            fields={handleReserveFields(reserve)}
                          />
                        </div>
                      )
                    )
                  )}
                </div>
              </div>

              <div className="tw-rounded tw-bg-white tw-overflow-hidden tw-flex tw-flex-col">
                <div className="listHeader tw-px-5 tw-py-3 tw-flex tw-justify-between tw-items-center">
                  <div className="tw-font-semibold tw-text-xs">
                    {vehiclesViewMode === VehiclesViewMode.LIST
                      ? `${dashboardData?.dashboardDatas?.vehicles?.vehicle_count || 0} Véhicules pour ${dashboardData?.dashboardDatas?.vehicles?.tours?.length || 0} tournées`
                      : `Répartition des ${dashboardData?.dashboardDatas?.map?.tours?.length || 0} tournées`}
                  </div>
                  <div className="tw-flex tw-gap-3 tw-items-center">
                    {vehiclesViewMode === VehiclesViewMode.LIST && (
                      <div
                        onClick={() => navigate('tours')}
                        className="tw-font-semibold tw-cursor-pointer tw-text-xs tw-underline tw-text-[#29A9A3]"
                      >
                        Voir plus
                      </div>
                    )}
                    {showVehiclesViewToggle && (
                      <div
                        className="tw-flex tw-items-center tw-rounded-lg tw-p-1 tw-gap-2"
                        data-tour="dashboard-view-toggle"
                      >
                        <FontAwesomeIcon
                          icon={faList}
                          className={`tw-text-sm tw-transition-colors ${vehiclesViewMode === VehiclesViewMode.LIST ? 'tw-text-[#29A9A3]' : 'tw-text-gray-300'}`}
                        />
                        <Switch
                          checked={vehiclesViewMode === VehiclesViewMode.MAP}
                          onChange={(checked) =>
                            setVehiclesViewMode(
                              checked
                                ? VehiclesViewMode.MAP
                                : VehiclesViewMode.LIST
                            )
                          }
                          className="tw-relative tw-inline-flex tw-h-6 tw-w-12 tw-cursor-pointer tw-rounded-full tw-border-2 tw-border-transparent tw-transition-colors tw-ease-in-out tw-duration-200 focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-white focus-visible:tw-ring-opacity-75"
                        >
                          <span
                            aria-hidden="true"
                            className={`${
                              vehiclesViewMode === VehiclesViewMode.MAP
                                ? 'tw-translate-x-5'
                                : 'tw-translate-x-0'
                            } tw-pointer-events-none tw-inline-block tw-h-5 tw-w-5 tw-transform tw-rounded-full tw-bg-white tw-shadow-lg tw-ring-0 tw-transition tw-duration-200 tw-ease-in-out`}
                          />
                        </Switch>
                        <FontAwesomeIcon
                          icon={faMap}
                          className={`tw-text-sm tw-transition-colors ${vehiclesViewMode === VehiclesViewMode.MAP ? 'tw-text-[#29A9A3]' : 'tw-text-gray-300'}`}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {vehiclesViewMode === VehiclesViewMode.LIST ? (
                  <div className="tw-rounded-md tw-bg-white tw-divide-solid tw-divide-x-0 tw-divide-y tw-divide-background tw-overflow-y-auto tw-flex-1">
                    {isLoading ? (
                      <GenericTableSkeleton />
                    ) : (
                      dashboardData?.dashboardDatas?.vehicles?.tours?.map(
                        (tour) => (
                          <div
                            onClick={() =>
                              handleTourModal(tour?.current_or_next_tour)
                            }
                            className=""
                            key={`tour_${tour?.current_or_next_tour?.tour_key}`}
                          >
                            <Row
                              iconColor={'tw-text-checklist-common'}
                              key={`tourRow_${tour?.current_or_next_tour?.tour_key}`}
                              title={computeTourTitle(tour)}
                              subtitle={
                                'Tour ' +
                                tour?.current_or_next_tour?.tour_number +
                                ' - Étape ' +
                                tour?.finalized_steps_count +
                                ' sur ' +
                                tour?.total_steps_count
                              }
                              icon={faTruck}
                              status={
                                tour_status?.properties[
                                  tour?.current_or_next_tour?.status
                                ]?.color
                              }
                              statusText={
                                tour_status?.properties[
                                  tour?.current_or_next_tour?.status
                                ]?.display_name
                              }
                              statusStyle={'tw-w-[90px]'}
                              style={'tw-cursor-pointer'}
                              fields={
                                tour?.current_or_next_tour?.tour_index
                                  ? [
                                      {
                                        name: 'Tournée',
                                        value:
                                          tour?.current_or_next_tour
                                            ?.tour_index +
                                          ' sur ' +
                                          tour?.tour_count,
                                      },
                                    ]
                                  : []
                              }
                            />
                          </div>
                        )
                      )
                    )}
                  </div>
                ) : (
                  <div className="tw-relative tw-box-border tw-p-2 tw-rounded tw-bg-white tw-flex-1 tw-overflow-hidden tw-z-0">
                    <div
                      onClick={() => setOpenMapModal(true)}
                      className="tw-absolute tw-bg-white tw-rounded-md tw-top-6 tw-right-6 tw-z-10 tw-h-[40px] tw-w-[40px] tw-flex tw-items-center tw-justify-center tw-cursor-pointer"
                    >
                      <FontAwesomeIcon
                        icon={faExpand}
                        className="tw-h-[20px] tw-w-[20px]"
                      />
                    </div>
                    <Suspense
                      fallback={
                        <div className="map-wrapper">
                          <SkeletonLoader height={'100%'} width={'100%'} />
                        </div>
                      }
                    >
                      {openMapModal ? null : (
                        <MapFleetDashboard
                          tours={dashboardData?.dashboardDatas?.map?.tours}
                          selectedTour={selectedTour}
                          setIsMapReady={setIsMapReady}
                        />
                      )}
                    </Suspense>
                  </div>
                )}
              </div>
            </div>

            <div className="tw-container tw-mx-auto tw-h-[35vh] tw-row-auto tw-grid tw-grid-flow-row tw-grid-cols-2 tw-grid-rows-1 tw-gap-4">
              <div
                className={`tw-rounded tw-bg-white tw-overflow-y-auto ${
                  isLoading ||
                  dashboardData?.dashboardDatas?.bar_chart_datas?.length > 0
                    ? 'tw-col-span-1'
                    : 'tw-col-span-2'
                }`}
              >
                {isLoading ? (
                  <SkeletonLoader height={'100%'} width={'100%'} />
                ) : (
                  <PieChartComponent
                    pie_chart_data={
                      dashboardData?.dashboardDatas?.pie_chart_datas?.[0]
                    }
                    startAngle={630}
                    endAngle={280}
                    innerRadius={'50%'}
                    fill="#8884d8"
                    paddingAngle={5}
                    hasTooltip={true}
                  />
                )}
              </div>

              {(isLoading ||
                dashboardData?.dashboardDatas?.bar_chart_datas?.length > 0) && (
                <div className="tw-rounded tw-bg-white tw-overflow-y-auto">
                  {isLoading ? (
                    <SkeletonLoader height={'100%'} width={'100%'} />
                  ) : (
                    <BarChartComponent
                      bar_chart_data={
                        dashboardData?.dashboardDatas?.bar_chart_datas?.[0]
                      }
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </GenericPageContainer>

      {/* Modale */}

      <ModalTour
        tourSelected={selectedTour}
        show={openTourModal}
        onHide={() => {
          setSelectedTour();
          setSelectedTourID();
          setOpenTourModal(false);
        }}
      />

      <ModalReserveV2
        show={modalHandleReserve}
        size={'lg'}
        onHide={(isReserveUpdated) => {
          setModalHandleReserve(false);
          setSelectedReserve(null);
          if (isReserveUpdated) {
            getData();
          }
        }}
        reserve_id={selectedReserve?.id}
      />

      <ResponsiblesNotificationModal
        show={openResponsiblesModal}
        onHide={() => setOpenResponsiblesModal(false)}
        date={filters?.date}
      />

      <Transition appear show={openMapModal}>
        <Dialog
          as="div"
          className="tw-relative tw-z-[100] focus:tw-outline-none tw-w-full tw-rounded-8xs tw-bg-white tw-box-border tw-flex tw-flex-col tw-items-start tw-justify-start tw-gap-[32px] tw-text-base tw-text-text-dark-high-importance tw-font-list-item-title border-[1px] tw-border-solid border-dimgray-100 tw-mq750:gap-[16px]"
          onClose={() => setOpenMapModal(false)}
        >
          <div
            className="tw-fixed tw-inset-0 tw-bg-black/40"
            aria-hidden="true"
          />
          <TransitionChild
            enter="tw-ease-out tw-duration-300"
            enterFrom="tw-opacity-0 tw-transform-[scale(95%)]"
            enterTo="tw-opacity-100 tw-transform-[scale(100%)]"
            leave="tw-ease-in tw-duration-200"
            leaveFrom="tw-opacity-100 tw-transform-[scale(100%)]"
            leaveTo="tw-opacity-0 tw-transform-[scale(95%)]"
          >
            <div className="tw-fixed tw-inset-0 tw-w-screen tw-overflow-y-auto tw-p-4 ">
              <div className="tw-flex tw-min-h-full tw-items-center tw-justify-center">
                <DialogPanel
                  className={`tw-flex tw-flex-col tw-max-h-[95vh] tw-w-full ${MODAL_SIZE_STYLE[MODAL_SIZE.XXXL]} tw-rounded tw-bg-white`}
                >
                  {/* Header */}
                  <div
                    className={`tw-flex tw-items-center tw-justify-between tw-py-3 tw-p-4 tw-border-solid tw-border-background tw-border-0 tw-border-b`}
                  >
                    <div className="tw-flex tw-font-semibold tw-text-base">
                      Répartition des{' '}
                      {dashboardData?.dashboardDatas?.map?.tours?.length}{' '}
                      tournées
                    </div>
                    <FontAwesomeIcon
                      onClick={() => setOpenMapModal(false)}
                      className="tw-size-5 tw-cursor-pointer tw-text-checklist-common"
                      icon={faTimes}
                    />
                  </div>
                  {/* Body */}
                  <div className={`tw-overflow-hidden tw-h-[850px]`}>
                    <div className=" tw-flex">
                      <div className="tw-rounded-md tw-bg-white tw-divide-solid tw-divide-x-0 tw-divide-y tw-divide-background tw-h-[850px] tw-min-w-[350px] tw-w-[350px] tw-overflow-y-scroll tw-overflow-x-hidden">
                        {isLoading ? (
                          <GenericTableSkeleton />
                        ) : (
                          dashboardData?.dashboardDatas?.map?.tours?.map(
                            (tour) => (
                              <div
                                className={`tw-flex tw-p-3 ${selectedTourID === tour?.tour_id ? 'tw-bg-[#07999218] tw-border tw-border-1 tw-border-[#079992] ' : null}`}
                                key={`tourMap_${tour?.tour_key}`}
                                onClick={() => setSelectedTourID(tour?.tour_id)}
                              >
                                <div className="tw-flex tw-items-center tw-justify-between tw-w-full">
                                  <div className="tw-flex  tw-items-center">
                                    <FontAwesomeIcon
                                      className={`tw-mr-2 tw-size-4`}
                                      icon={faRoute}
                                      color="#8B8B8B"
                                    />
                                    <div className="tw-max-w-xl">
                                      <div className="tw-text-smi tw-font-work tw-leading-4 tw-mb-1">
                                        {tour?.tour_key}
                                      </div>
                                      <div className="tw-text-smi tw-font-work tw-text-text-dark-medium-importance tw-leading-4 tw-line-clamp-1">
                                        {tour?.last_step_delivered_if_any?.order
                                          ? 'Étape ' +
                                            tour?.last_step_delivered_if_any
                                              ?.order
                                          : "A l'usine"}
                                      </div>
                                    </div>
                                  </div>
                                  <>
                                    <Status
                                      status={
                                        tour_status?.properties?.[tour.status]
                                          ?.color
                                      }
                                      text={
                                        tour_status?.properties?.[tour.status]
                                          ?.display_name
                                      }
                                      style={''}
                                    />
                                  </>
                                  <Checkbox
                                    checked={selectedTourID === tour?.tour_id}
                                    className="tw-group tw-block tw-size-4 tw-rounded tw-border tw-bg-white data-[checked]:tw-bg-[#079992]"
                                  >
                                    <span className="tw-invisible tw-size-2 tw-rounded-full tw-bg-white group-data-[checked]:tw-visible" />
                                  </Checkbox>
                                </div>
                              </div>
                            )
                          )
                        )}
                      </div>
                      <div className="tw-w-full tw-h-[850px]">
                        <Suspense
                          fallback={
                            <div className="map-wrapper ">
                              <SkeletonLoader height={'100%'} width={'100%'} />
                            </div>
                          }
                        >
                          <MapFleetDashboard
                            tours={dashboardData?.dashboardDatas?.map?.tours}
                            selectedTour={selectedTour}
                            setIsMapReady={setIsMapReady}
                            origin={'modal'}
                          />
                        </Suspense>
                      </div>

                      {selectedTourID ? (
                        <div
                          className=" tw-bg-white tw-h-[850px] tw-min-w-[400px] tw-w-[400px] tw-overflow-y-scroll tw-overflow-x-hidden"
                          ref={sectionRef}
                        >
                          <section className="tw-self-stretch tw-flex tw-flex-col tw-items-stretch tw-justify-start tw-gap-6 tw-p-5 tw-overflow-y-auto tw-flex-auto">
                            {/* main row */}
                            <div className=" tw-justify-start tw-max-w-full">
                              <div className="tw-items-start tw-justify-between tw-w-full mq750:tw-flex-wrap">
                                {/* left part */}
                                <div className=" tw-items-start tw-justify-start tw-px-0 tw-pb-0 tw-text-text-dark-high-importance">
                                  <div className=" tw-items-center tw-justify-start tw-shrink-0">
                                    <div className=" tw-items-start tw-justify-start tw-px-0 tw-pb-0">
                                      <div className="tw-w-6 tw-h-6 tw-relative tw-flex tw-items-center">
                                        <FontAwesomeIcon
                                          icon={faRoute}
                                          className="tw-text-icon-gray"
                                        />
                                      </div>
                                    </div>
                                    {/* header */}
                                    <div className="tw-items-start tw-justify-start tw">
                                      <div className="tw-relative tw-font-medium tw-font-work tw-text-sm">
                                        <span>
                                          Tour{' '}
                                          {selectedTour
                                            ? selectedTour?.tour_key
                                            : '-'}
                                        </span>
                                      </div>
                                      <div className="tw-items-start tw-justify-start tw-gap-[8.5px] tw-text-smi tw-text-gray-600">
                                        <div className="list-item-title tw-text-gray-600">
                                          {features?.OTHERS?.UPLOAD
                                            ?.tourCreationDateUsed
                                            ? selectedTour?.creation_date
                                              ? config?.client_id === 5
                                                ? `Chargée à ${moment(selectedTour?.creation_date).format('HH[h]mm')}`
                                                : `Intégrée à ${moment(selectedTour?.creation_date).format('DD/MM/YYYY')}`
                                              : '-'
                                            : selectedTour?.starting_date
                                              ? `Départ à ${moment(selectedTour?.starting_date).format('HH[h]mm')}`
                                              : '-'}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className=" tw-items-center tw-justify-start tw-gap-4 tw-shrink-0 tw-max-w-full tw-text-smi mq450:tw-flex-wrap">
                                  {/* key and value */}
                                  <div className="tw-flex tw-flex-col tw-items-start tw-justify-start tw-gap-0.5">
                                    <div className="list-item-title tw-text-text-dark-high-importance">
                                      Kilomètres de départ
                                    </div>
                                    <div className="list-item-title tw-text-gray-600">
                                      {selectedTour?.last_kilometers
                                        ? selectedTour.last_kilometers
                                        : '0'}{' '}
                                      km
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Separator */}
                            <div className="tw-h-[1px] tw-w-full tw-bg-black tw-opacity-20" />

                            {/* Scrollable content */}
                            <div className="tw-pb-16 tw-gap-6 tw-overflow-y-auto tw-flex tw-flex-col tw-items-stretch tw-justify-start tw-relative tw-max-w-full tw-text-smi tw-text-text-dark-high-importance">
                              {/* tour steps block */}
                              <div className="tw-flex tw-flex-col tw-items-start tw-justify-start tw-max-w-full tw-text-gray-600">
                                {/* section header */}
                                <div className="tw-flex tw-flex-col tw-pb-6 tw-text-base tw-text-text-dark-high-importance">
                                  <div className="tw-relative tw-font-medium">
                                    Liste des étapes
                                  </div>
                                  <div className="tw-relative tw-text-smi tw-leading-[15px] tw-text-text-dark-medium-importance">
                                    Retrouvez la liste des étapes du tour
                                  </div>
                                </div>
                                {/* section table header */}

                                {/* section content */}
                                {details?.steps?.map((step) => {
                                  return (
                                    <div
                                      key={`_step_${step.step_id}`}
                                      className="tw-self-stretch tw-flex tw-flex-col tw-items-end tw-justify-start tw-pt-4 tw-px-0 tw-pb-4 tw-gap-4 tw-shrink-0 tw-max-w-full tw-text-sm tw-border-solid tw-border-background tw-border-0 tw-border-b"
                                    >
                                      {/* main step row */}
                                      <div className="tw-self-stretch tw-flex tw-flex-row tw-items-start tw-justify-start [row-gap:20px] tw-max-w-full tw-text-right tw-text-smi tw-text-text-dark-high-importance">
                                        <div className="tw-flex-1 tw-overflow-hidden tw-flex tw-flex-col tw-items-start tw-justify-start tw-gap-[2.1px] tw-min-w-[150px] tw-max-w-full tw-text-left">
                                          <div className="tw-flex tw-flex-row tw-items-start tw-justify-start tw-gap-[16px] tw-text-sm">
                                            <div className="tw-flex tw-flex-row tw-items-start tw-justify-start">
                                              <div className="tw-h-4 tw-w-[50px] tw-relative">
                                                <div
                                                  className={`tw-w-[25px] tw-h-[25px] tw-font-bold tw-bg-[#079992] tw-text-white tw-flex tw-justify-center tw-items-center tw-rounded-full`}
                                                >
                                                  {step.order}
                                                </div>
                                                {/* <FontAwesomeIcon
                                            icon={faTruck}
                                            className="tw-text-icon-gray tw-absolute tw-top-0 tw-left-0 tw-w-6 tw-h-6 tw-text-2xl"
                                          /> */}
                                              </div>
                                              <div className="tw-flex tw-flex-col tw-items-start tw-justify-start">
                                                <div className="tw-relative tw-font-semibold tw-flex tw-gap-4 tw-text-sm">
                                                  <div className="">
                                                    {step?.step_key
                                                      ? `Étape ${step.step_key}`
                                                      : 'STEP_NAME'}
                                                  </div>
                                                </div>
                                                <div className="list-item-title">
                                                  {formatAddress(
                                                    step?.end_address
                                                  )}
                                                </div>

                                                <div className="tw-flex-1 tw-flex tw-flex-row tw-items-start tw-justify-start [row-gap:20px] tw-text-xs ">
                                                  <div className="tw-flex-1 tw-relative tw-text-smi tw-tracking-[-0.02em] tw-text-text-dark-high-importance tw-min-w-[129px] tw-shrink-0">
                                                    Kilomètres saisis :{' '}
                                                    <span className="tw-font-semibold">
                                                      {step?.inputted_kilometers
                                                        ? step.inputted_kilometers +
                                                          ' km'
                                                        : 'nc.'}
                                                    </span>
                                                  </div>
                                                </div>

                                                <div className="tw-flex-1 tw-flex tw-flex-col tw-items-start tw-justify-start">
                                                  <div className="tw-flex-1 tw-relative tw-text-smi tw-tracking-[-0.02em] tw-text-text-dark-high-importance tw-min-w-[129px] tw-shrink-0 tw-w-full">
                                                    Arrivée et Départ :{' '}
                                                    <span className="tw-font-semibold">
                                                      {step?.arrival_date
                                                        ? moment(
                                                            step?.arrival_date
                                                          ).format('HH[h]mm')
                                                        : 'nc.'}{' '}
                                                      -{' '}
                                                      {step?.departure_date
                                                        ? moment(
                                                            step?.departure_date
                                                          ).format('HH[h]mm')
                                                        : 'nc.'}
                                                    </span>
                                                  </div>
                                                </div>

                                                <div className="tw-flex-1 tw-flex tw-flex-col tw-items-end tw-justify-start tw-gap-[4px] tw-text-center tw-text-xs tw-text-text-dark-medium-importance">
                                                  <Status
                                                    status={
                                                      step_status.properties[
                                                        step.status
                                                      ].style
                                                    }
                                                    text={
                                                      step_status.properties[
                                                        step.status
                                                      ]?.display_name
                                                    }
                                                    style={'tw-my-1'}
                                                  />

                                                  {step?.additional_datas
                                                    ?.need_to_disinfect ? (
                                                    <div className="tw-rounded-3xs tw-bg-goldenrod tw-flex tw-flex-row tw-items-start tw-justify-start tw-py-px tw-px-[7px] tw-whitespace-nowrap tw-text-black tw-border-[1px] tw-border-solid tw-border-dimgray-200">
                                                      <div className="tw-relative tw-font-medium tw-inline-block ">
                                                        Risque sanitaire
                                                      </div>
                                                    </div>
                                                  ) : null}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {/* comments */}
                                      <div className="tw-flex tw-flex-col tw-pl-[50px] tw-items-start tw-justify-start tw-gap-3 tw-w-full">
                                        <div className="tw-relative tw-tracking-[-0.02em] tw-font-medium">
                                          Commentaire d’étape
                                        </div>
                                        <div className="tw-self-stretch tw-rounded-[3px] tw-bg-whitesmoke-100 tw-box-border tw-flex tw-flex-row tw-flex-wrap tw-items-center tw-justify-start tw-py-3.5 tw-pr-3.5 tw-pl-4 tw-gap-[16px] tw-max-w-full tw-text-smi tw-text-text-dark-medium-importance tw-border-[1px] tw-border-solid tw-border-border-primary-strong">
                                          <div className="tw-flex tw-flex-col tw-items-start tw-justify-start ">
                                            <FontAwesomeIcon
                                              icon={faComment}
                                              className="tw-text-icon-gray tw-w-4 tw-h-4"
                                            />
                                          </div>
                                          <p className="tw-flex-1 tw-relative tw-tracking-[-0.02em] tw-mb-0 tw-leÉing-4">
                                            {step?.comments
                                              ? step.comments
                                              : 'Pas de commentaire pour cette étape'}
                                          </p>
                                        </div>
                                      </div>
                                      <div className="tw-flex tw-flex-col tw-pl-[50px] tw-items-start tw-justify-start tw-gap-3 tw-w-full">
                                        <div className="tw-relative tw-tracking-[-0.02em] tw-font-medium">
                                          Numéros de commande
                                        </div>
                                        <div className="tw-w-full tw-flex tw-flex-col tw-gap-3">
                                          {step?.bls?.map((bl) => {
                                            const IconComponent =
                                              DELIVERY_DETAIL_TYPE.properties[
                                                bl?.delivery_type
                                              ].icon;

                                            return (
                                              <div
                                                key={`${bl.delivery_detail_id}`}
                                                className="tw-self-stretch tw-rounded-10xs tw-bg-whitesmoke-100 tw-box-border tw-flex tw-flex-row tw-flex-wrap tw-items-start tw-justify-between tw-py-2 tw-pr-[17px] tw-pl-[15px] tw-max-w-full tw-gap-[20px] tw-text-smi tw-text-text-dark-high-importance tw-border-[1px] tw-border-solid tw-border-border-primary-strong"
                                              >
                                                <div className="tw-flex tw-flex-row tw-items-start tw-justify-start tw-gap-2">
                                                  {/* <div className="tw-flex tw-flex-col tw-items-start tw-justify-start tw-pt-2 tw-px-0 tw-pb-0">
                                                <FontAwesomeIcon
                                                  icon={faTruck}
                                                  className="tw-text-icon-gray tw-w-6 tw-h-5"
                                                />
                                              </div> */}
                                                  <IconComponent className="tw-text-icon-gray tw-w-8 tw-h-8" />
                                                  <div className="tw-flex tw-flex-col tw-items-start tw-justify-start tw-gap-3">
                                                    <div className="tw-flex tw-flex-row tw-items-start">
                                                      <div className="tw-flex tw-flex-row tw-items-start tw-justify-start tw-gap-3">
                                                        <div className="tw-flex tw-flex-col tw-items-start tw-justify-start tw-gap-0.5">
                                                          <div className="tw-relative tw-font-medium tw-text-sm">
                                                            {bl?.delivery_detail_key
                                                              ? `Commande ${bl.delivery_detail_key}`
                                                              : ' nc.'}
                                                          </div>
                                                          <div className="tw-relative tw-text-text-dark-medium-importance list-item-title">
                                                            {step?.end_address
                                                              ?.name
                                                              ? step
                                                                  ?.end_address
                                                                  ?.name
                                                              : 'nc.'}
                                                          </div>
                                                        </div>
                                                        <div className="tw-h-[33px] tw-flex tw-flex-col tw-items-center tw-justify-start">
                                                          <img
                                                            className="tw-w-[13.6px] tw-h-[13.5px] tw-relative"
                                                            loading="lazy"
                                                            alt=""
                                                            src="/icon-akartrianglealertfill.svg"
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="tw-flex tw-flex-col tw-items-start tw-justify-start tw-gap-[1px] tw-text-right tw-text-xs tw-text-primary">
                                                      {bl?.documents?.map?.(
                                                        (el) => (
                                                          <div
                                                            key={`el_${el.id}`}
                                                            className="tw-relative [text-decoration:underline] tw-tracking-[0.02em]"
                                                          >
                                                            <a
                                                              href={el.url}
                                                              target="_blank"
                                                              rel="noreferrer"
                                                            >
                                                              Télécharger{' '}
                                                              {el?.doc_type
                                                                ? DOCUMENT_TYPE
                                                                    .properties[
                                                                    el?.doc_type
                                                                  ]?.pronoun
                                                                : 'la'}{' '}
                                                              {el?.doc_type
                                                                ? DOCUMENT_TYPE
                                                                    .properties[
                                                                    el?.doc_type
                                                                  ]
                                                                    ?.display_name
                                                                : 'DOCUMENT_TYPE'}
                                                            </a>
                                                          </div>
                                                        )
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="tw-flex tw-flex-row tw-items-center tw-justify-start tw-align-center  tw-w-full tw-gap-4">
                                                  <div className="tw-h-[53px] tw-w-[1px] tw-relative tw-bg-black tw-opacity-5" />
                                                  {/* ddd */}
                                                  <div className="tw-flex tw-flex-col tw-gap-1.5 tw-align-stretch tw-w-full">
                                                    <Products
                                                      bl={bl}
                                                      features={features}
                                                      client_id={
                                                        config?.client_id
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>

                              {/* tour comments block */}
                              <div className="tw-self-stretch tw-flex tw-flex-col tw-items-start tw-justify-start tw-gap-[33px] tw-shrink-0 [debug_commit:bf4bc93] tw-max-w-full tw-text-base mq750:tw-gap-[16px]">
                                {/* section header */}
                                <div className="tw-flex tw-flex-col tw-pb-0 tw-text-base tw-text-text-dark-high-importance">
                                  <div className="tw-relative tw-font-medium">
                                    Informations supplémentaires sur la tournée
                                  </div>
                                  <div className="tw-relative tw-text-smi tw-leading-[15px] tw-text-text-dark-medium-importance">
                                    Documents de fin de tournée et commentaires
                                    de par l'équipe de planification.
                                  </div>
                                </div>
                                {/* comments */}
                                <div className="tw-flex tw-flex-col tw-w-full tw-gap-2">
                                  <div className="tw-self-stretch tw-rounded-[3px] tw-bg-whitesmoke-100 tw-box-border tw-flex tw-flex-row tw-flex-wrap tw-items-start tw-justify-start tw-py-3.5 tw-pr-3.5 tw-pl-4 tw-gap-[16px] tw-max-w-full tw-text-smi tw-text-text-dark-medium-importance tw-border-[1px] tw-border-solid tw-border-border-primary-strong">
                                    <div className="tw-flex tw-flex-col tw-items-start tw-justify-start ">
                                      <FontAwesomeIcon
                                        icon={faComment}
                                        className="tw-text-icon-gray tw-w-4 tw-h-4"
                                      />
                                    </div>
                                    <p className="tw-flex-1 tw-relative tw-tracking-[-0.02em] tw-mb-0 tw-leading-4">
                                      {details?.tour_comments
                                        ? details.tour_comments
                                        : 'Pas de commentaire pour cette tournée'}
                                    </p>
                                  </div>
                                  {/* comments */}
                                  <div className="tw-self-stretch tw-rounded-[3px] tw-bg-whitesmoke-100 tw-box-border tw-flex tw-flex-row tw-flex-wrap tw-items-start tw-justify-start tw-py-3.5 tw-pr-3.5 tw-pl-4 tw-gap-[16px] tw-max-w-full tw-text-smi tw-text-text-dark-medium-importance tw-border-[1px] tw-border-solid tw-border-border-primary-strong">
                                    <div className="tw-flex tw-flex-col tw-items-start tw-justify-start ">
                                      <FontAwesomeIcon
                                        icon={faClipboard}
                                        className="tw-text-icon-gray tw-w-4 tw-h-4"
                                      />
                                    </div>
                                    <p className="tw-flex-1 tw-relative tw-tracking-[-0.02em] tw-mb-0 tw-leading-4">
                                      {details?.tour_documents.length
                                        ? details.tour_documents?.map((el) => (
                                            <div
                                              key={`el_${el.id}`}
                                              className="tw-relative [text-decoration:underline] tw-tracking-[0.02em]"
                                            >
                                              <a
                                                href={el.url}
                                                target="_blank"
                                                rel="noreferrer"
                                              >
                                                Télécharger{' '}
                                                {el?.doc_type
                                                  ? DOCUMENT_TYPE.properties[
                                                      el?.doc_type
                                                    ]?.pronoun
                                                  : 'la'}{' '}
                                                {el?.doc_type
                                                  ? DOCUMENT_TYPE.properties[
                                                      el.doc_type
                                                    ]?.display_name
                                                  : 'DOCUMENT_TYPE'}
                                              </a>
                                            </div>
                                          ))
                                        : 'Pas de documents pour cette tournée'}
                                    </p>
                                  </div>
                                </div>
                              </div>

                              {/* Localisation des étapes block */}
                              {false && (
                                <div className="tw-flex tw-flex-col tw-pb-0 tw-text-base tw-text-text-dark-high-importance">
                                  {/* section header */}
                                  <div className="tw-flex tw-flex-col tw-pb-6 tw-text-base tw-text-text-dark-high-importance">
                                    <div className="tw-relative tw-font-medium">
                                      Localisation des étapes
                                    </div>
                                    <div className="tw-relative tw-text-smi tw-leading-[15px] tw-text-text-dark-medium-importance">
                                      Localisation des étapes de la tournées sur
                                      la carte
                                    </div>
                                  </div>
                                  {/* map */}
                                  <div className="tw-self-stretch tw-h-[300px] tw-rounded-3xs tw-bg-white tw-box-border tw-overflow-x-auto tw-shrink-0 tw-flex tw-flex-row tw-items-start tw-justify-start tw-pt-[68.9px] tw-px-[387px] tw-pb-[61px] tw-gap-[98.9px] tw-text-smi tw-text-white tw-font-montserrat tw-border-[1px] tw-border-solid tw-border-border-primary-strong mq1150:tw-gap-[49px] mq1150:tw-pl-[193px] mq1150:tw-pr-[193px] tw-box-border mq450:tw-pl-5 mq450:tw-pr-5 tw-box-border mq750:tw-gap-[25px] mq750:tw-pl-24 mq750:tw-pr-24">
                                    <div className="tw-h-[300px] tw-w-[1250px] tw-relative tw-rounded-3xs tw-bg-white tw-box-border tw-shrink-0 tw-hidden tw-border-[1px] tw-border-solid tw-border-border-primary-strong" />
                                    <img
                                      className="tw-h-[272.9px] tw-w-[1226.5px] tw-relative tw-shrink-0 tw-object-contain tw-hidden"
                                      alt=""
                                      src="/groupe-de-masques-10@2x.png"
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          </section>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  {/* Footer */}
                </DialogPanel>
              </div>
            </div>
          </TransitionChild>
        </Dialog>
      </Transition>
    </>
  );
};

export default HomeV3;
